import React, { useState } from 'react';
import oscarHero from './assets/oscar-hero.png';

/**
 * Oscar — the guest-facing concierge companion. Chunky, short, rounded, white/chrome
 * body, big glowing blue eyes (the host's approved render, background-removed to a
 * transparent PNG). `pose` floats a small accessory (wave / heart / flowers / point /
 * celebrate / book). If the image ever fails to load we fall back to the CSS Oscar so
 * the flow never shows a broken graphic.
 */
const POSE_EMOJI = { wave: '👋', heart: '💛', flowers: '💐', point: '👉', celebrate: '🎉', book: '📖' };

function CssOscar() {
  return (
    <>
      <div className="ohead" />
      <div className="oface"><span className="oeye l" /><span className="oeye r" /></div>
      <div className="obody" />
      <div className="opin">M</div>
    </>
  );
}

export default function Oscar({ pose = '', size = 150, src = oscarHero, alt = 'Oscar, your guide' }) {
  const [failed, setFailed] = useState(false);
  const useImg = src && !failed;
  return (
    <div className="vgb-oscar" style={{ '--osz': `${size}px` }} role="img" aria-label={alt}>
      <div className="obob">
        {useImg
          ? <img src={src} alt={alt} onError={() => setFailed(true)}
                 style={{ width: '100%', height: '100%', objectFit: 'contain' }} draggable="false" />
          : <CssOscar />}
        {pose && POSE_EMOJI[pose] ? <span className="opose" aria-hidden="true">{POSE_EMOJI[pose]}</span> : null}
      </div>
    </div>
  );
}
